import React, {Component} from 'react';
import {connect} from 'react-redux';
import CircularProgress from '@material-ui/core/CircularProgress';
import {setScrollHeight} from "../redux/actions";

export default function asyncComponent(importComponent, loaderStubComponent = <CircularProgress/>) {
    class AsyncFunc extends Component {
        constructor(props) {
            super(props);
            this.state = {
                component: null
            };
            this.mounted = false;
        }

        async componentDidMount() {
            this.mounted = true;
            console.log('loading component...');
            const {default: Component} = await importComponent();
            console.log('component was loaded');
            if (this.mounted) {
                this.setState({
                    component: <Component {...this.props}/>
                }, () => {
                    console.log('component was set in state');
                    setTimeout(this.props.setScrollHeight, 1000);
                });
            }
        }

        componentWillUnmount() {
            this.mounted = false;
        }

        renderLoading() {
            return loaderStubComponent;
        }

        render() {
            const {loading, loaded} = this.props;
            const {component} = this.state;

            if (loading || !loaded || !component) {
                return this.renderLoading();
            }

            return component;
        }
    }

    const mapStateToProps = ({asyncInitialState}, ownProps) => {
        const {loading, loaded} = asyncInitialState;
        return {loading, loaded,};
    };

    return connect(mapStateToProps, {setScrollHeight})(AsyncFunc);
}